import { Component, Input, OnInit } from '@angular/core';
import { Options } from 'ngx-slider-v2';
import { StatisticsSummaryService } from '@services/statistics/statistics-summary.service';
import { FilterMenuOption } from '@pages/statistics/shared/interfaces/statistics';

@Component({
  selector: 'app-stats-slider',
  templateUrl: './stats-slider.component.html',
  styleUrls: ['./stats-slider.component.scss']
})
export class StatsSliderComponent implements OnInit {
  @Input() menuTitle = '';
  @Input() currency = '';
  @Input() filterOption?: FilterMenuOption;
  @Input() minValue = 0;
  @Input() maxValue = 1000;
  @Input() rangeStep? = 0;

  public options: Options = {
    floor: 0,
    ceil: 60000,
    step: 0.01,
    ticksArray: []
  };
  public value = 12;

  constructor(private statistics: StatisticsSummaryService) {}

  ngOnInit(): void {
    if (this.menuTitle === 'leads') {
      this.options.step = 1;
    }
    if (this.filterOption && this.filterOption.unit !== 'currency') {
      this.currency = this.filterOption.unit ?? '';
      if (!this.filterOption.unit) {
        this.currency = '';
      }
    }
    this.options.step = this.rangeStep;
    this.options.ceil = this.maxValue;
  }

  public setValue(event: Event, valueType: string, modelValue: string): void {
    if (!this.filterOption) return;

    const value = (event.target as HTMLInputElement).value;
    //@ts-ignore
    this.filterOption[valueType as keyof FilterMenuOption] = value;

    if (
      !value ||
      (modelValue === 'minValue' && parseInt(value) < this.filterOption[modelValue as keyof FilterMenuOption]) ||
      (modelValue === 'maxValue' && parseInt(value) > this.filterOption[modelValue as keyof FilterMenuOption])
    ) {
      //@ts-ignore
      this.filterOption[valueType as keyof FilterMenuOption] = this.filterOption[modelValue as keyof FilterMenuOption];
    }
  }

  public resetValues(): void {
    this.statistics.setCampaignRangeSliderValues([this.minValue, this.maxValue], this.menuTitle.toUpperCase());
  }

  public getSliderMinMaxValue(): Array<any> {
    const values = [this.filterOption?.currentMinValue, this.filterOption?.currentMaxValue, this.menuTitle];
    return values;
  }
}
